import { enqueueSnackbar } from 'notistack'

export const showToast = (message, options = {}) => {
  if (options.variant === 'error') {
    options.persist = options.persist ?? true
  }
  enqueueSnackbar(message, options)
}
